var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideDashHeading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.625C0 1.17559 0.351116 0.8125 0.785714 0.8125H1.96429H3.14286C3.57746 0.8125 3.92857 1.17559 3.92857 1.625C3.92857 2.07441 3.57746 2.4375 3.14286 2.4375H2.75V5.28125H8.25V2.4375H7.85714C7.42254 2.4375 7.07143 2.07441 7.07143 1.625C7.07143 1.17559 7.42254 0.8125 7.85714 0.8125H9.03571H10.2143C10.6489 0.8125 11 1.17559 11 1.625C11 2.07441 10.6489 2.4375 10.2143 2.4375H9.82143V6.09375V10.5625H10.2143C10.6489 10.5625 11 10.9256 11 11.375C11 11.8244 10.6489 12.1875 10.2143 12.1875H9.03571H7.85714C7.42254 12.1875 7.07143 11.8244 7.07143 11.375C7.07143 10.9256 7.42254 10.5625 7.85714 10.5625H8.25V6.90625H2.75V10.5625H3.14286C3.57746 10.5625 3.92857 10.9256 3.92857 11.375C3.92857 11.8244 3.57746 12.1875 3.14286 12.1875H1.96429H0.785714C0.351116 12.1875 0 11.8244 0 11.375C0 10.9256 0.351116 10.5625 0.785714 10.5625H1.17857V6.09375V2.4375H0.785714C0.351116 2.4375 0 2.07441 0 1.625Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_2483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDashHeading);
export default __webpack_public_path__ + "static/media/sideDashHeading.9cd7edc3bb1bd7c1ed1b5683ab57991f.svg";
export { ForwardRef as ReactComponent };